import { render } from "./CreateSurvey.vue?vue&type=template&id=31c943b2&scoped=true&ts=true"
import script from "./CreateSurvey.vue?vue&type=script&lang=ts"
export * from "./CreateSurvey.vue?vue&type=script&lang=ts"

import "./CreateSurvey.vue?vue&type=style&index=0&id=31c943b2&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c943b2"]])

export default __exports__